import meter1 from "../assets/img/meter1.svg";
import meter2 from "../assets/img/meter2.svg";
import meter3 from "../assets/img/meter3.svg";
import Carousel from 'react-multi-carousel';
import 'react-multi-carousel/lib/styles.css';
import colorSharp from "../assets/img/color-sharp.png";

export const Skills = () => {
  const responsive = {
    superLargeDesktop: {
      breakpoint: { max: 4000, min: 3000 },
      items: 5
    },
    desktop: {
      breakpoint: { max: 3000, min: 1024 },
      items: 3
    },
    tablet: {
      breakpoint: { max: 1024, min: 464 },
      items: 2
    },
    mobile: {
      breakpoint: { max: 464, min: 0 },
      items: 1
    }
  };

  return (
    <section className="skill" id="skills">
        <div className="container">
            <div className="row">
                <div className="col-12">
                    <div className="skill-bx wow zoomIn">
                        <h2>Skills</h2>
                        <p>Soy un desarrollador front-end en formación full-stack, especializado en diseño responsivo, accesibilidad y creación de experiencias web interactivas. Disfruto trabajar en equipo y gestionar proyectos de manera eficiente. Tengo experiencia en el manejo de APIs y bases de datos, integrando sistemas de forma fluida. Me apasiona resolver problemas y mejorar continuamente mis habilidades para desarrollar soluciones innovadoras</p>
                        <Carousel responsive={responsive} infinite={true} className="owl-carousel owl-theme skill-slider">
                            <div className="item">
                                <img src={meter1} alt="React" />
                                <h5>React</h5>
                            </div>
                            <div className="item">
                                <img src={meter1} alt="Desarrollo Web" />
                                <h5>Web Development</h5>
                            </div>
                            <div className="item">
                                <img src={meter3} alt="Node.js|Expressjs|NextjsL" />
                                <h5>Node.js|Expressjs|Nextjs</h5>
                            </div>
                            <div className="item">
                                <img src={meter3} alt="JavaScript" />
                                <h5>JavaScript</h5>
                            </div>
                                <div className="item">
                                <img src={meter2} alt="APIs y NoSQL" />
                                <h5>APIs y NoSQL</h5>
                            </div>
                            <div className="item">
                                <img src={meter1} alt="Front-end" />
                                <h5>FullStack</h5>
                            </div>
                        </Carousel>
                    </div>
                </div>
            </div>
        </div>
        <img className="background-image-left" src={colorSharp} alt="Decoración" />
    </section>
  );
};
